import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { hsvToHsl, hslToHsv } from '@rhino/shared/services/shared';
import { addToQueue } from '@rhino/shared/services/redux/prefsSlice';
import { AppDispatch, RootState } from './store';
import { fnAdmin_PullPageSettings } from '@rhino/shared/services/sputnikapi';
// import { useAppDispatch } from '@rhino/shared/services/redux/hooks';
// import { SputnikDeviceAttributes } from './sputnikdevicesSlice';

export type FlashSpeed = {
  speedIn:number;
  speedOut:number;
}
export type ColorData = {
  flashSpeed: FlashSpeed;
  mode: string;
  hslColour: [number,number,number];
};

export type SceneData = {
  sceneId: string;
  sceneName: string;
  colors: ColorData[];
  hexString: string;
};
export interface tuyascenes {
  scenes: { [sceneId: string]: SceneData };
}

const initialState: tuyascenes = {
  scenes: {}
};


export const updatetuyaScenesSliceAsync = createAsyncThunk(
  "tuyascenes/setScene",
  async (payload: { sceneId: number, scene: SceneData }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;

    try {
      // console.log('dispatching', payload);
      // Dispatch action with merged value
      try {
        dispatch(setScene(payload));
      } catch (oError) {
        console.error(oError);
      }

      // Retrieve the entire tuyascenes state
      const tuyascenes = (getState() as RootState).tuyascenes;

      // Send merged value to the server
      // console.log('send update to server',payload);
      dispatch(addToQueue({
        type: 9,
        prefname: '',
        keyaddress: payload.sceneId.toString(),
        keyvalue: tuyascenes.scenes
      }));

    } catch (oErr) {
      console.error(oErr);
    }
  }
);

export const fetchTuyaScenes = createAsyncThunk(
  "tuyascenes/fetchDetails",
  async (_, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch as AppDispatch;

      await fetchScenesFromDB(dispatch);
    } catch (error) {
      console.error("Error fetching spread details:", error);

      return thunkAPI.rejectWithValue(error);
    }
  }
);

const tuyaScenesSlice = createSlice({
  name: 'tuyaScenes',
  initialState,
  reducers: {
    setScenes: (state, action: PayloadAction<tuyascenes>) => {
      state.scenes = { ...action.payload.scenes };
    },
    
    setScene: (state, action: PayloadAction<{sceneId:number, scene: SceneData}>) => {
      state.scenes[action.payload.sceneId.toString().padStart(2, '0')] = action.payload.scene;
    },

    
  }
});

export const {
  setScenes,setScene
} = tuyaScenesSlice.actions;

export const selectScenes = (state: RootState) => {
  return state.tuyascenes;
}
export const selectScene = (state: RootState, sceneId: string) => {
  return state.tuyascenes.scenes[sceneId];
}


  
export default tuyaScenesSlice.reducer;

const mapScenesFromDB = (scenesFromDB: any[]): SceneData[] => {
  return scenesFromDB.map(sceneFromDB => {
    const sceneData = interpretString(sceneFromDB.hexString);
    sceneData.sceneName = sceneFromDB.sceneName;  // Update the scene name
    return sceneData;
  });
};
// Create a set of unique sputnik device codes
async function fetchScenesFromDB(
  dispatch: AppDispatch
) {
  // local for now, move to db call later
  // const scenesFromDB = [
  //   {'sceneID':10,'sceneName': 'Night', 'hexString': '000e0d00002e03e802cc00000000'},
  //   {'sceneID':1,'sceneName': 'Read', 'hexString': '010d0d000084000003e800000000'},
  //   {'sceneID':2,'sceneName': 'Working', 'hexString': '020d0d00001403e803e800000000'},
  //   {'sceneID':3,'sceneName': 'Leisure', 'hexString': '030e0d0000e80383031c00000000'},
  //   {'sceneID':4,'sceneName': 'Soft', 'hexString': '04464602007803e803e800000000464602007803e8000a00000000'},
  //   {'sceneID':5,'sceneName': 'Colourful', 'hexString': '05464601000003e803e800000000464601007803e803e80000000046460100f003e803e800000000'},
  //   {'sceneID':6,'sceneName': 'Dazzling', 'hexString': '06464601000003e803e800000000464601007803e803e800000000'},
  //   {'sceneID':7,'sceneName': 'Gorgeous', 'hexString': '07464602000003e803e800000000464602007803e803e80000000046460200f003e803e800000000464602003d03e803e80000000046460200ae03e803e800000000464602011303e803e800000000'},
  //   {'sceneID':8,'sceneName': 'fullspeed', 'hexString': '04646402007803e803e800000000646402007803e8000a00000000'},
  //   {'sceneID':9,'sceneName': 'slowest', 'hexString': '04282802007803e803e800000000282802007803e8000a00000000'},
  //   {'sceneID':11,'sceneName': 'LED Scene 05', 'hexString': '055c5c02000003e803e8000000005c5c02001e03e803e8000000005c5c02002f03e803e8000000005c5c02007803e803e8000000005c5c0200f003e803e8000000005c5c0200f302230175000000005c5c02011103e803e800000000'},
  //   {'sceneID':12,'sceneName': 'LED Scene 07', 'hexString': '07464602000003e803e800000000464602007803e803e80000000046460200f003e803e800000000464602003d03e803e80000000046460200ae03e803e800000000464602011303e803e800000000'},
  //   {'sceneID':13,'sceneName': 'LED Scene 00', 'hexString': '0055550200e703e803e80000000055550200c503e803e80000000055550200c003e8000a000000005555020013000003e80000000055550200cf03e8000a0000000055550200c103e803e80000000055550200e103e803e800000000'}
  // ]
  // console.log(JSON.stringify(scenesFromDB))

  
  fnAdmin_PullPageSettings('nebulonscenes', dispatch,{})
      .then(response => {
          // console.log(response)
          if (response.success) {
              // console.log(response.data)
              const scenesArray = mapScenesFromDB(response.data); // This returns an array of SceneData

              const scenesDict = scenesArray.reduce<{ [key: string]: SceneData }>((accumulator, currentScene) => {
                accumulator[currentScene.sceneId] = currentScene;
                return accumulator;
              }, {});
              
              dispatch(setScenes({scenes:scenesDict}));
              // response.data.forEach((deviceData:[number, string, string, string, string]) => {
              //   const [sputnikdeviceid, sputnikDeviceCode, name, attributes, status] = deviceData;
              //   const tSputDev = {sputnikdeviceid:sputnikdeviceid
              //     ,sputnikDeviceCode:sputnikDeviceCode
              //     ,attributes:fnJSONParse(attributes)
              //     ,status:fnJSONParse(status)
              //   }
              //   // console.log(tLookup,sputnikDeviceCode,`[${sputnikDeviceCode}]`)
              //   // console.log(fnDictGetIndex(tLookup,sputnikDeviceCode,undefined,[]))
              //   fnDictGetIndex(tLookup,sputnikDeviceCode,undefined,[])?.forEach((nebulonTileID: string) => {
              //     dispatch(setTileProperty({ nebulonTileID, keyaddress: 'sputnikDevice', keyvalue: tSputDev }));
              //   });                
                
              // });
          
              // dispatch(setSpread(response.data))
          } else {
              throw new Error(`Server response was false: ${JSON.stringify(response.data)}`); 
          }
      })
      .catch(error => {
        console.error(error)
          // Handle errors from either API call
          // if (fnConsoleError) fnConsoleError("Unable to load initial data", error);
      });
};


function interpretFlashSpeed(speedCode: string): FlashSpeed {
  const speedIn = parseInt(speedCode.substring(0, 2), 16);
  const speedOut = parseInt(speedCode.substring(2, 4), 16);

  return {speedIn:speedIn,speedOut:speedOut}
}
function reverseFlashSpeed(flashSpeed:FlashSpeed) {
  let speedInHex = flashSpeed.speedIn.toString(16).padStart(2, '0');
  let speedOutHex = flashSpeed.speedOut.toString(16).padStart(2, '0');
  return speedInHex + speedOutHex;
}

function interpretMode(modeCode: string): string {
  switch (modeCode) {
    case '00': return 'static';
    case '01': return 'flash';
    case '02': return 'breathe';
    default: return 'unknown';
  }
}
function reverseMode(mode:string) {
  switch (mode) {
    case 'static': return '00';
    case 'flash': return '01';
    case 'breathe': return '02';
    default: return 'FF'; // Unknown mode
  }
}


export function interpretString(input: string): SceneData {
  // Validate input length
  if (input.length < 28 || (input.length - 2) % 26 !== 0) {
    throw new Error("Invalid input length");
  }

  const sceneId = input.substring(0, 2);
  let currentIndex = 2;
  const scene: SceneData = {sceneId:sceneId,sceneName:"name",colors:[],hexString:input};

  while (currentIndex < input.length) {
    const flashSpeedCode = input.substring(currentIndex, currentIndex + 4);
    const flashSpeed = interpretFlashSpeed(flashSpeedCode);
    const modeCode = input.substring(currentIndex + 4, currentIndex + 6);
    const mode = interpretMode(modeCode);
    const hslColour = hsvToHsl(
      parseInt(input.substring(currentIndex + 6, currentIndex + 10), 16),
      parseInt(input.substring(currentIndex + 10, currentIndex + 14), 16)/10,
      parseInt(input.substring(currentIndex + 14, currentIndex + 18), 16)/10
    );    
    // const hsvColour = `H: ${parseInt(input.substring(currentIndex + 6, currentIndex + 10), 16)}, S: ${parseInt(input.substring(currentIndex + 10, currentIndex + 14), 16)}, V: ${parseInt(input.substring(currentIndex + 14, currentIndex + 18), 16)}`;
    scene.colors.push({ flashSpeed, mode, hslColour });
    currentIndex += 26;
  }

  return scene;
}

export function reverseInterpretString(scene:SceneData) {
  // console.log(scene)
  let outputString = scene.sceneId.toString().padStart(2, '0');

  scene.colors.forEach(color => {
    const flashSpeedCode = reverseFlashSpeed(color.flashSpeed);
    const modeCode = reverseMode(color.mode);
    const [H, S, V] = hslToHsv(color.hslColour[0], color.hslColour[1], color.hslColour[2]);

    // Convert HSV values to the required format and to hex
    const hueHex = Math.round(H).toString(16).padStart(4, '0');
    const satHex = Math.round(S * 10).toString(16).padStart(4, '0');
    const valHex = Math.round(V * 10).toString(16).padStart(4, '0');
    const hsvColour = `${hueHex + satHex + valHex}00000000`;
    outputString += `${flashSpeedCode + modeCode + hsvColour}`;
  });

  return outputString;
}
